import { useEffect, useState } from 'react';
import {
  getCachedProfileImageUrl,
  loadProfileImageUrl,
} from '../utils/profileImageCache';

export default function useProfileImage(type, id, hasProfileImage, refreshKey = 0, options = {}) {
  const { enabled = true, lazy = false } = options;
  const [url, setUrl] = useState(() => getCachedProfileImageUrl(type, id));

  useEffect(() => {
    if (!enabled || !hasProfileImage || !id || !type) {
      setUrl(null);
      return undefined;
    }

    const cached = getCachedProfileImageUrl(type, id);
    if (cached) {
      setUrl(cached);
      return undefined;
    }

    let cancelled = false;

    const load = () => {
      loadProfileImageUrl(type, id).then((nextUrl) => {
        if (!cancelled) setUrl(nextUrl);
      });
    };

    if (lazy) {
      if (typeof window.requestIdleCallback === 'function') {
        const idleId = window.requestIdleCallback(load, { timeout: 500 });
        return () => {
          cancelled = true;
          window.cancelIdleCallback(idleId);
        };
      }
      const timer = setTimeout(load, 120);
      return () => {
        cancelled = true;
        clearTimeout(timer);
      };
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [type, id, hasProfileImage, refreshKey, enabled, lazy]);

  return url;
}
